export default function LogoutButton({ onLogout }) {
    const handleLogout = () => {
        fetch(`${process.env.REACT_APP_API_URL}/auth/logout`, {
            credentials: "include"
        })
            .then(() => onLogout())
            .catch(err => console.error(err));
    };

    return (
        <div className="logout-button">
            <button onClick={handleLogout}>Logout</button>
        </div>
    );
}
